import * as Yup from "yup";
import form from "pages/calculator/36months/schemas/form";

const {
  formField: {
    ASQ3Communication_CutoffLB,
    ASQ3Communication_CutoffUB,
    ASQ3GrossMotor_CutoffLB,
    ASQ3GrossMotor_CutoffUB,
    ASQ3FineMotor_CutoffLB,
    ASQ3FineMotor_CutoffUB,
    ASQ3ProblemSolving_CutoffLB,
    ASQ3ProblemSolving_CutoffUB,
    ASQ3PersonalSocial_CutoffLB,
    ASQ3PersonalSocial_CutoffUB,
    ASQ3_SE2_CutoffLB,
    ASQ3_SE2_CutoffUB,
    SDQ_Total_CutoffB1,
    SDQ_Total_CutoffB2,
    SDQ_Total_CutoffB3,
    SDQ_EmotionalProb_CutoffB1,
    SDQ_EmotionalProb_CutoffB2,
    SDQ_EmotionalProb_CutoffB3,
    SDQ_ConductProb_CutoffB1,
    SDQ_ConductProb_CutoffB2,
    SDQ_ConductProb_CutoffB3,
    SDQ_Hyperactivity_CutoffB1,
    SDQ_Hyperactivity_CutoffB2,
    SDQ_Hyperactivity_CutoffB3,
    SDQ_PeerProb_CutoffB1,
    SDQ_PeerProb_CutoffB2,
    SDQ_PeerProb_CutoffB3,
    SDQ_Prosocial_CutoffB1,
    SDQ_Prosocial_CutoffB2,
    SDQ_Prosocial_CutoffB3,
  },
} = form;

const noValidation = Yup.object().shape({});

const validations = Yup.object().shape({
  [ASQ3Communication_CutoffLB.name]: Yup.string()
    .required(ASQ3Communication_CutoffLB.errorMsg)
    .max(200, ASQ3Communication_CutoffLB.invalidMsg),
  [ASQ3Communication_CutoffUB.name]: Yup.string()
    .required(ASQ3Communication_CutoffUB.errorMsg)
    .max(200, ASQ3Communication_CutoffUB.invalidMsg),
  [ASQ3GrossMotor_CutoffLB.name]: Yup.string()
    .required(ASQ3GrossMotor_CutoffLB.errorMsg)
    .max(200, ASQ3GrossMotor_CutoffLB.invalidMsg),
  [ASQ3GrossMotor_CutoffUB.name]: Yup.string()
    .required(ASQ3GrossMotor_CutoffUB.errorMsg)
    .max(200, ASQ3GrossMotor_CutoffUB.invalidMsg),
  [ASQ3FineMotor_CutoffLB.name]: Yup.string()
    .required(ASQ3FineMotor_CutoffLB.errorMsg)
    .max(200, ASQ3FineMotor_CutoffLB.invalidMsg),
  [ASQ3FineMotor_CutoffUB.name]: Yup.string()
    .required(ASQ3FineMotor_CutoffUB.errorMsg)
    .max(200, ASQ3FineMotor_CutoffUB.invalidMsg),
  [ASQ3ProblemSolving_CutoffLB.name]: Yup.string()
    .required(ASQ3ProblemSolving_CutoffLB.errorMsg)
    .max(200, ASQ3ProblemSolving_CutoffLB.invalidMsg),
  [ASQ3ProblemSolving_CutoffUB.name]: Yup.string()
    .required(ASQ3ProblemSolving_CutoffUB.errorMsg)
    .max(200, ASQ3ProblemSolving_CutoffUB.invalidMsg),
  [ASQ3PersonalSocial_CutoffLB.name]: Yup.string()
    .required(ASQ3PersonalSocial_CutoffLB.errorMsg)
    .max(200, ASQ3PersonalSocial_CutoffLB.invalidMsg),
  [ASQ3PersonalSocial_CutoffUB.name]: Yup.string()
    .required(ASQ3PersonalSocial_CutoffUB.errorMsg)
    .max(200, ASQ3PersonalSocial_CutoffUB.invalidMsg),
  [ASQ3_SE2_CutoffLB.name]: Yup.string()
    .required(ASQ3_SE2_CutoffLB.errorMsg)
    .max(200, ASQ3_SE2_CutoffLB.invalidMsg),
  [ASQ3_SE2_CutoffUB.name]: Yup.string()
    .required(ASQ3_SE2_CutoffUB.errorMsg)
    .max(200, ASQ3_SE2_CutoffUB.invalidMsg),
  [SDQ_Total_CutoffB1.name]: Yup.string()
    .required(SDQ_Total_CutoffB1.errorMsg)
    .max(200, SDQ_Total_CutoffB1.invalidMsg),
  [SDQ_Total_CutoffB2.name]: Yup.string()
    .required(SDQ_Total_CutoffB2.errorMsg)
    .max(200, SDQ_Total_CutoffB2.invalidMsg),
  [SDQ_Total_CutoffB3.name]: Yup.string()
    .required(SDQ_Total_CutoffB3.errorMsg)
    .max(200, SDQ_Total_CutoffB3.invalidMsg),
  [SDQ_EmotionalProb_CutoffB1.name]: Yup.string()
    .required(SDQ_EmotionalProb_CutoffB1.errorMsg)
    .max(200, SDQ_EmotionalProb_CutoffB1.invalidMsg),
  [SDQ_EmotionalProb_CutoffB2.name]: Yup.string()
    .required(SDQ_EmotionalProb_CutoffB2.errorMsg)
    .max(200, SDQ_EmotionalProb_CutoffB2.invalidMsg),
  [SDQ_EmotionalProb_CutoffB3.name]: Yup.string()
    .required(SDQ_EmotionalProb_CutoffB3.errorMsg)
    .max(200, SDQ_EmotionalProb_CutoffB3.invalidMsg),
  [SDQ_ConductProb_CutoffB1.name]: Yup.string()
    .required(SDQ_ConductProb_CutoffB1.errorMsg)
    .max(200, SDQ_ConductProb_CutoffB1.invalidMsg),
  [SDQ_ConductProb_CutoffB2.name]: Yup.string()
    .required(SDQ_ConductProb_CutoffB2.errorMsg)
    .max(200, SDQ_ConductProb_CutoffB2.invalidMsg),
  [SDQ_ConductProb_CutoffB3.name]: Yup.string()
    .required(SDQ_ConductProb_CutoffB3.errorMsg)
    .max(200, SDQ_ConductProb_CutoffB3.invalidMsg),
  [SDQ_Hyperactivity_CutoffB1.name]: Yup.string()
    .required(SDQ_Hyperactivity_CutoffB1.errorMsg)
    .max(200, SDQ_Hyperactivity_CutoffB1.invalidMsg),
  [SDQ_Hyperactivity_CutoffB2.name]: Yup.string()
    .required(SDQ_Hyperactivity_CutoffB2.errorMsg)
    .max(200, SDQ_Hyperactivity_CutoffB2.invalidMsg),
  [SDQ_Hyperactivity_CutoffB3.name]: Yup.string()
    .required(SDQ_Hyperactivity_CutoffB3.errorMsg)
    .max(200, SDQ_Hyperactivity_CutoffB3.invalidMsg),
  [SDQ_PeerProb_CutoffB1.name]: Yup.string()
    .required(SDQ_PeerProb_CutoffB1.errorMsg)
    .max(200, SDQ_PeerProb_CutoffB1.invalidMsg),
  [SDQ_PeerProb_CutoffB2.name]: Yup.string()
    .required(SDQ_PeerProb_CutoffB2.errorMsg)
    .max(200, SDQ_PeerProb_CutoffB2.invalidMsg),
  [SDQ_PeerProb_CutoffB3.name]: Yup.string()
    .required(SDQ_PeerProb_CutoffB3.errorMsg)
    .max(200, SDQ_PeerProb_CutoffB3.invalidMsg),
  [SDQ_Prosocial_CutoffB1.name]: Yup.string()
    .required(SDQ_Prosocial_CutoffB1.errorMsg)
    .max(200, SDQ_Prosocial_CutoffB1.invalidMsg),
  [SDQ_Prosocial_CutoffB2.name]: Yup.string()
    .required(SDQ_Prosocial_CutoffB2.errorMsg)
    .max(200, SDQ_Prosocial_CutoffB2.invalidMsg),
  [SDQ_Prosocial_CutoffB3.name]: Yup.string()
    .required(SDQ_Prosocial_CutoffB3.errorMsg)
    .max(200, SDQ_Prosocial_CutoffB3.invalidMsg),
});

export { validations as default, noValidation };
